<template>
  <div id="imageGallery">
    <div class="container p-md-0 text-center " id="galleryContainer">
      <div class="gallery">
        <div class="row">
          <div class="col-md-4 col-sm-6 col-12" v-for="photo in photos" :key="photo.id"
               @click="showPhoto(photo.id)">
            <div class="photo-frame sec-garay-bg border-radius gallery">
              <v-img :src="$replaceHttps(photo.urlThumbnail)" height="300"
                     alt="photoGallery"></v-img>
            </div>
          </div>
            <div class=" pager-frame mx-auto " >
              <ul class=" row pager-frame ">
                <li v-for="page in idxLastPage" :key="page.id" class="page li p-2 m-1 bg-primary rounded "
                    :class="{ active: (idxCurrentPage+1) == page }"
                    @click="paginate(page-1)">
                  <a class="white--text" href="#">{{ page }}</a>
                </li>
              </ul>
            </div>
        </div>
      </div>
      <div id="overlay" v-show="isShowPhoto" @click="isShowPhoto=false"></div>
      <div id="layout" v-show="isShowPhoto" @click="isShowPhoto=false" class="row no-gutters ">
        <div class="next col-1 vertical-center-wrapper" @click.stop="goNextPhoto()"><span>&lt;</span></div>
        <div class="col-10 mx-auto" ref="scrollToMe">
          <img v-if="showPhotoUrl !== ''" :src="showPhotoUrl"
               alt="" class="img-fluid" style="overflow: auto">
        </div>
        <div class="prev col-1 vertical-center-wrapper" @click.stop="goPrevPhoto()"><span> > </span></div>
      </div>
    </div>
  </div>
</template>

<script>
//let allPhotos = null;
let _this = null;
export default {
  props: ['galleryItems'],
  name: "imageGallery",
  data: () => ({
    allPhotos: null, // all photos
    photos: [],           // photos in the current page
    photosPerPage: 6,    // photos per page
    idxLastPhoto: 0,      // last photo's id
    idxCurrentPage: 0,    // current photo's id
    idxLastPage: 0,       // last page's id
    isShowPhoto: false,   //
    showPhotoUrl: '',     // selected photo url
    idxCurrentPhoto: 0    // current photo index
  }),
  mounted() {
    _this = this;
    console.log('22222', this.galleryItems)
    console.log('22222', this.galleryItems.length)
    this.allPhotos = this.getPhotos(this.galleryItems);
    //allPhotos = this.allPhotos;

    // init indexes
    //this.idxLastPhoto = this.allPhotos.length === 1 ? 1 : this.allPhotos.length - 1;
    this.idxLastPhoto = this.allPhotos.length;

    this.idxLastPage = Math.floor(this.allPhotos.length / this.photosPerPage);

    // show first page
    this.paginate(0);
  },
  methods: {
    paginate: function (idxPage) {
      this.idxCurrentPage = idxPage;

      // determine period
      // TODO
      let idxStart = Math.ceil(idxPage * this.photosPerPage);
      let idxEnd = idxStart + this.photosPerPage > this.idxLastPhoto + 1 ?
          this.idxLastPhoto : idxStart + this.photosPerPage;


      console.log("ZZZZZZ");
      console.log(idxStart);
      console.log(idxEnd);
      console.log(this.allPhotos.length);

      // drop the visible photos
      this.photos.splice(0, this.photos.length)


      console.log(this.photos);
      // reload visible photos from all photo

      for (var idx = idxStart; idx < idxEnd; idx++) {
        this.photos.push(this.allPhotos[idx]);
      }
    },

    /**
     * Show image preview larger
     */
    showPhoto: function (id) {

      let that = this;
      // find photo data by id
      this.allPhotos.forEach(function (photo, idx) {
        if (photo.id === id) {
          // lock background and show photo
          that.isShowPhoto = true;
          that.showPhotoUrl = photo.urlPhoto;
          that.idxCurrentPhoto = idx;

          const el = _this.$refs.scrollToMe;
          if (el) {
            // Use el.scrollIntoView() to instantly scroll to the element
            el.scrollIntoView({behavior: 'smooth'});
          }
          // go top of the page
        }
      });
    },
    goPrevPhoto: function () {
      var current = this.idxCurrentPhoto;
      this.showPhoto(this.allPhotos[current === 0 ? this.idxLastPhoto - 1 : current - 1].id);

    },
    goNextPhoto: function () {
      var current = this.idxCurrentPhoto;
      this.showPhoto(this.allPhotos[current === this.idxLastPhoto - 1 ? 0 : current + 1].id);
    },

    getPhotos: function (images) {
      let photos = [];

      console.log(images)

      for (let i = 0; i < images.length; i++) {

        if (images[i].imageUrl !== null) {
          photos.push({
            urlPhoto: images[i].imageUrl,
            urlThumbnail: images[i].imageUrl,
            id: i,
            title: images[i].title !== undefined ? images[i].title : images[i].application
          });
        }

      }

      console.log("photos");
      console.log(photos);

      return photos;
    },


  }


}
</script>

<style scoped>

</style>